<mat-card appearance="outlined" *ngIf="fetchingError">
  <mat-card-content class="row">
    <mat-icon class="no-flex">error</mat-icon>
    <span>Error when fetching configurations. Make sure the chargepoint is online and try again.</span>
  </mat-card-content>
</mat-card>


<div>
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
</div>

<ng-container *ngIf="(traces$ | async) as traces">
  <div class="toolbar">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
        <input matStartDate formControlName="start" placeholder="Start date">
        <input matEndDate formControlName="end" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <mat-paginator [length]="total$ | async"
                [pageIndex]="(page$ | async)?.pageIndex ?? 0"
                [pageSize]="(page$ | async)?.pageSize ?? 10"
                [pageSizeOptions]="[10, 25, 100]"
                (page)="onPageChange($event)">
    </mat-paginator>
  </div>
  <mat-accordion>
    <mat-expansion-panel *ngFor="let trace of traces">
      <mat-expansion-panel-header>
        <mat-panel-title>{{trace.time | date:'medium'}}</mat-panel-title>
        <mat-panel-description>
          <span class="status-chip" [ngStyle]="{'background-color': getTraceBGColor(trace), 'color': getTraceColor(trace)}">{{trace.name}}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      
      <ngx-json-viewer [json]="trace.payload" [depth]="2"></ngx-json-viewer>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>